import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'

import { useGetQuery } from '../../lib/api/get'
import { useUpdateCall } from '../../lib/api/update'
import { useGetMutateCall } from '../../lib/api/get'
import { CheckInCard } from './checkInCard'

//import checkBoxImg from '../../assets/images/checkbox.svg'
import { ActivityModal } from './ActivityModal'
import { NoDataCard } from '../../common/NoDataCard'
import { ClassActivityModal } from './ClassActivityModal'

export const ChildAttendance = ({ isLocalEnvironment, envData, authDetails, routeData }) => {
  var curr = new Date()
  curr.setDate(curr.getDate())
  const getCallMutation = useGetMutateCall()
  const [dates, setDates] = React.useState(curr.toISOString().substring(0, 10))
  const [roomVal, setRoomVal] = React.useState(null)
  const [updatingNow, setUpdatingNow] = React.useState(null)
  const [autoRefresh] = React.useState(false)
  const [openActivity, setOpenActivity] = React.useState(false)
  const [openClassActivity, setOpenClassActivity] = React.useState(false)
  const [activityAttenInd, setActivityAttenInd] = React.useState(null)
  const [dataForAtten, setDataForAtten] = React.useState(null)
  const [selectedApplData, setSelectedApplData] = React.useState({
    data: { formData: [] },
  })

  const [updating, setUpdating] = React.useState(false)
  const [selectRoom, setSelectRoom] = React.useState(false)

  const getData = useGetQuery({
    apiURL: isLocalEnvironment + '/getData',
    apiEndpoint: 'staffClassRoom',
    params: '',
    isDynamic: true,
  })

  const getOnchangeAppl = async (e, roomId, onLoad = false) => {
    //setDates(e)
    let rVal = onLoad ? '&classRoomId=' + roomId : ''
    if (roomVal !== null && roomVal !== '') {
      rVal = '&classRoomId=' + roomVal
    } else {
      if (!onLoad) {
        console.log('')
        setSelectRoom(true)
        return
      }
    }
    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'attendance',
        params: '&checkInDateTime=' + dayjs.utc(dates).format('YYYY-MM-DD HH:mm:ss') + rVal,
        doPolling: false,
        isDynamic: true,
      })
      .then((resp) => {
        setSelectedApplData(resp.formData)
        var refreshInt
        if (autoRefresh) {
          clearTimeout(refreshInt)
          refreshInt = setTimeout(function () {
            getOnchangeAppl(e)
          }, 120000)
        }
      })
  }

  React.useEffect(() => {
    if (getData.data?.formData) {
      const defRoom = getData.data?.formData.filter((f) => f.isPrimary === 1)
      setRoomVal(defRoom[0].classRoomId)
      getOnchangeAppl(new Date(), defRoom[0].classRoomId, true)
    }
  }, [])

  const closeActivityModal = () => {
    setActivityAttenInd(null)
    setOpenActivity(false)
  }

  const updateCallMutation = useUpdateCall()

  const onSubmit = async (data, cInd, type) => {
    setUpdating(true)
    setUpdatingNow(cInd)
    const payload = { ...data }
    payload['attendanceType'] = type

    await updateCallMutation
      .mutateAsync({
        url: isLocalEnvironment + '/updateData',
        apiEndpoint: type === 3 ? 'check-out-confirmation' : 'check-in-confirmation',
        invalidateWithParams: true,
        data: payload, // data,
        id: payload.attendanceId,
        messageTitle: 'Attendance',
        message: 'Attendance updated successfully!',
        params: '',
        noConfirmation: true,
        isDynamic: true,
      })
      .then(async () => {
        await getCallMutation
          .mutateAsync({
            apiURL: isLocalEnvironment + '/getData',
            apiEndpoint: 'attendance',
            params:
              '&checkInDateTime=' +
              dayjs.utc(dates === null ? new Date() : dates).format('YYYY-MM-DD HH:mm:ss') +
              `&classRoomId=${roomVal}`,
            doPolling: autoRefresh,
            isDynamic: true,
          })
          .then((resp) => {
            setSelectedApplData(resp.formData)
            setUpdating(false)
          })
          .catch(() => {
            setUpdating(false)
          })
      })
    setUpdatingNow(null)
  }
  const isLayoutDark = sessionStorage.getItem('themeLayout')
    ? sessionStorage.getItem('themeLayout')
    : false

  if (getData.isLoading) {
    return (
      <div>
        <div
          id="status"
          className="trtui-align-items-center trtui-d-none trtui-d-md-block trtui-justify-content-center"
          style={{
            width: '40px',
            height: '40px',
            position: 'absolute',
            left: '50%',
            top: '50%',
            margin: '-20px 0 0 6.4rem',
          }}
        >
          <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
            <span className="trtui-visually-hidden">Loading...</span>
          </div>
        </div>
        <div
          id="status"
          className="trtui-align-items-center trtui-d-block trtui-d-md-none trtui-justify-content-center"
          style={{
            width: '40px',
            height: '40px',
            position: 'absolute',
            left: '20%',
            top: '50%',
            margin: '-20px 0 0 6.4rem',
          }}
        >
          <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
            <span className="trtui-visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <React.Fragment key={isLayoutDark}>
      <div className="trtui-row">
        <div className="trtui-col-12">
          <div className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between">
            <h4 className="trtui-mb-sm-0">{routeData.pageTitle}</h4>
            <div className="trtui-row">
              <div key="room" className="trtui-col-md-4 trtui-has-validation">
                <select
                  className={`trtui-form-control trtui-mb-2 ${selectRoom && 'trtui-is-invalid'}`}
                  style={{
                    paddingRight: 'calc(1.5em + 1rem)',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                    backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
                  }}
                  onChange={(e) => setRoomVal(e.target.value)}
                >
                  <option value={''}>Select Room</option>
                  {getData.data?.formData?.length > 0 &&
                    getData.data?.formData?.map((r, rInd) => (
                      <option
                        key={rInd}
                        value={r.classRoomId}
                        selected={roomVal === r.classRoomId ? true : false}
                      >
                        {r.staffClass.classRoomName}
                      </option>
                    ))}
                </select>
                {selectRoom && <div className="trtui-invalid-feedback">Select Room</div>}
              </div>
              <div key="date" className="trtui-col-md-4">
                <input
                  type="date"
                  className="trtui-form-control"
                  onChange={(e) => setDates(e.target.value)}
                  defaultValue={dates}
                />
              </div>
              <div key="autoRefresh" className="trtui-col-md-4">
                {/* Auto Refresh{' '}
                <input
                  className="trtui-form-check-input"
                  type="checkbox"
                  onChange={() => setAutoRefresh(!autoRefresh)}
                  style={{
                    '--vz-form-check-bg-image': `url(${checkBoxImg})`,
                  }}
                  checked={autoRefresh}
                ></input> */}
                <button
                  className={`trtui-btn trtui-btn-primary`}
                  type="button"
                  onClick={() => getOnchangeAppl('date')}
                >
                  <i className="ri-search-line" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {getCallMutation.isLoading ? (
        <div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-none trtui-d-md-block trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '50%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-block trtui-d-md-none trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '20%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="trtui-row">
          {selectedApplData.length > 0 && (
            <div className="trtui-col-12 trtui-mb-2">
              <div className="trtui-d-flex trtui-align-items-lg-center trtui-flex-lg-row trtui-flex-column">
                <div className="trtui-mt-lg-0">
                  <div className="trtui-row trtui-g-3 trtui-mb-0 trtui-align-items-center">
                    <div className="col-auto">
                      <button
                        type="button"
                        className="trtui-btn trtui-btn-sm trtui-btn-primary"
                        onClick={() => setOpenClassActivity(true)}
                      >
                        <i className="ri-add-circle-line trtui-align-middle trtui-me-1"></i> Add
                        Activity
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {selectedApplData.length > 0 ? (
            selectedApplData
              .sort((a, b) => new Date(b.checkInDateTime) - new Date(a.checkInDateTime))
              .map((card, cardInd) => (
                <CheckInCard
                  key={cardInd}
                  cardData={card}
                  onSubmit={onSubmit}
                  openActivity={setOpenActivity}
                  updating={updating}
                  setOpenActivity={closeActivityModal}
                  setActivityAttenInd={setActivityAttenInd}
                  activityAttenInd={activityAttenInd}
                  cardInd={cardInd}
                  updatingNow={updatingNow}
                />
              ))
          ) : (
            <NoDataCard key={isLayoutDark} isLayoutDark={isLayoutDark} />
          )}
        </div>
      )}
      {openActivity && routeData.noActivity !== true && (
        <ActivityModal
          isLocalEnvironment={isLocalEnvironment}
          envData={envData}
          authDetails={authDetails}
          setOpenActivity={closeActivityModal}
          activityAttenInd={activityAttenInd}
          modSchema={JSON.parse(routeData.apiEndPointSchema)}
          childFormData={selectedApplData[activityAttenInd]}
          defaultData={selectedApplData[activityAttenInd]}
          dataForAtten={dataForAtten}
          roomVal={roomVal}
          autoRefresh={autoRefresh}
          dates={dates}
          setSelectedApplData={setSelectedApplData}
          setDataForAtten={setDataForAtten}
        />
      )}
      {openClassActivity && (
        <ClassActivityModal
          isLocalEnvironment={isLocalEnvironment}
          envData={envData}
          authDetails={authDetails}
          setOpenClassActivity={setOpenClassActivity}
          modSchema={JSON.parse(routeData.apiEndPointSchema)}
          defaultData={selectedApplData}
          setSelectedApplData={setSelectedApplData}
          roomVal={roomVal}
          autoRefresh={autoRefresh}
          dates={dates}
        />
      )}
    </React.Fragment>
  )
}

ChildAttendance.propTypes = {
  isLocalEnvironment: PropTypes.string,
  envData: PropTypes.object,
  authDetails: PropTypes.object,
  routeData: PropTypes.object,
}
